import { ReactNode } from 'react';
import { StatusBadge } from '../ui/StatusBadge';
import type { SupportBadgeTone } from '../../utils/supportDeskBadges';

type SupportToneBadgeProps = {
  tone?: SupportBadgeTone;
  children: ReactNode;
  className?: string;
};

export function SupportToneBadge({
  tone = 'neutral',
  children,
  className = '',
}: SupportToneBadgeProps) {
  return (
    <StatusBadge tone={tone} className={className}>
      {children}
    </StatusBadge>
  );
}
